const NODE_ENV = process.env.NODE_ENV
// const baseURL= NODE_ENV == "development" ? "http://192.165.0.230:10047/management" : "/routeapi/management";
const baseURL = NODE_ENV == 'development' ? 'https://dap.hexfuture.net/routeapi/management' : '/routeapi/management'
export default baseURL

// 接口文档地址 http://192.168.5.52:10047/management/swagger-ui.html#/
